export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona account dell'offerente"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account dell'offerente"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}